import dashboard from './images/svg/dashboard.svg';
import notification from './images/svg/notification.svg';
import settings from './images/svg/settings.svg';
import userlist from './images/svg/user-list.svg';
import editpage from './images/svg/edit-page.svg';
import changepassword from './images/svg/change-password.svg';
import profile from './images/svg/profile.svg';
import profilegrey from './images/svg/profile-grey.svg';
import dashicon1 from './images/svg/dash1.svg';
import dashicon2 from './images/svg/dash2.svg';
import dashicon3 from './images/svg/dash3.svg';
import dashicon4 from './images/svg/dash4.svg';
import save from './images/svg/save.svg';
import edit from './images/svg/edit.svg';
import blueedit from './images/svg/blue-edit.svg';
import trash from './images/svg/trash.svg';
import yelloweye from './images/svg/yellow-eye.svg';
import plus from './images/svg/plus.svg';
import down from './images/svg/down.svg';
import search from './images/svg/search.svg';
import closecircle from './images/svg/close-circle.svg';
import bergurmenu from './images/svg/bergur-menu.svg';
import paginationleft from './images/svg/pagination-left.svg';
import paginationright from './images/svg/pagination-left.svg';
import filter from './images/svg/filter.svg';
import close from './images/svg/close.svg';
import instagram from './images/svg/instagram.svg'
import youtube from './images/svg/youtube.svg'
import skype from './images/svg/skype.svg'
import linkdin from './images/svg/linkedin.svg'
import twitter from './images/svg/twitter.svg'
import closeblack from './images/svg/close-black.svg'
import deleteicon from './images/svg/delete.svg'
import facebook from './images/svg/facebook.svg'
import discord from './images/svg/discord.svg'
import usercard from './images/svg/user-card.svg'











const Svg = {
    dashboard,
    notification,
    settings,
    changepassword,
    editpage,
    userlist,
    profile,
    dashicon1,
    dashicon2,
    dashicon3,
    dashicon4,
    save,
    edit,
    blueedit,
    trash,
    yelloweye,
    plus,
    down,
    search,
    closecircle,
    profilegrey,
    bergurmenu,
    paginationleft,
    paginationright,
    filter,
    close,
    instagram,
    youtube,
    skype,
    twitter,
    linkdin,
    closeblack,
    deleteicon,
    facebook,
    discord,
    usercard,
}

export default Svg;